import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { VERBOSITY, API_BASE_URL } from '../constants';

interface Appointment {
  id: string;
  when: string;
  duration: number;
  type: string;
  [key: string]: any;
}

export function ObsoleteAppointmentPage() {
  const [appointments, setAppointments] = useState<Appointment[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleEdit = (appointmentId: string) => {
    console.log("handleEdit: appointmentId=" + appointmentId);
    
    if (!appointmentId) {
      console.error('appointmentId is undefined');
      return;
    }
    
    localStorage.setItem('selectedAppointmentId', appointmentId);
    navigate('/booking');
  };

  useEffect(() => {
    const fetchAppointments = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setError('Not authenticated');
        setLoading(false);
        return;
      }

      try {
        const apiCall = API_BASE_URL + '/appointments/search';
        // Get appointment IDs: /api/appointments/search
        const userId = 'user1001';
        const searchRes = await fetch(apiCall, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify({ userId }),
        });

        if (!searchRes.ok) throw new Error('Suche erfolglos');
        
        const appointmentIds = await searchRes.json();

        // Get full appointment details
        const appointmentPromises = appointmentIds.map(async (id: string) => {
          // `/api/appointments/get-full-appointment/${id}`
          const apiCallFull = API_BASE_URL + '/appointments/get-full-appointment/' + id;
          const res = await fetch(apiCallFull, {
            headers: {
              'Authorization': `Bearer ${token}`,
            },
          });
          if (!res.ok) throw new Error(`Fehler ${id}`);
          return res.json();
        });

        const appointmentDetails = await Promise.all(appointmentPromises);
        console.log('Appointment details:', appointmentDetails);
        setAppointments(appointmentDetails);
      } catch (err) {
        setError(`Fehler: ${err}`);
      } finally {
        setLoading(false);
      }
    };

    fetchAppointments();
  }, []);

  if (loading) return <div className="text-center p-4">Loading appointments...</div>;
  if (error) return <div className="text-red-600 p-4">{error}</div>;

  const formatDate = (when: string) => {
    const date = new Date(when);
    const weekdays = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
    const weekday = weekdays[date.getDay()];
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString().slice(-2);
    return `${weekday} ${day}.${month}.${year}`;
  };

  const formatTime = (when: string) => {
    const date = new Date(when);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  return (
    <div className="max-w-4xl mx-auto mt-8 p-6 bg-white rounded-lg shadow-md">
      <h1 className="text-2xl font-bold mb-6 text-center">Termine</h1>
      
      <p className="mb-6 text-gray-600">Guten Tag Anna Patient, sie haben zwei Termine bei uns. Um zu verschieben bitte Ändern drücken.</p>

      {appointments.length > 0 ? (
        <div className="overflow-x-auto">
          <table className="w-full border-collapse border border-gray-300">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 px-4 py-2 text-left">Datum</th>
                <th className="border border-gray-300 px-4 py-2 text-left">Zeit</th>
                <th className="border border-gray-300 px-4 py-2 text-left">Dauer</th>
                <th className="border border-gray-300 px-4 py-2 text-left">Typ</th>
                <th className="border border-gray-300 px-4 py-2 text-left">Aktion</th>
              </tr>
            </thead>
            <tbody>
              {appointments.map((appointment) => (
                <tr key={appointment.id} className="hover:bg-gray-50">
                  <td className="border border-gray-300 px-4 py-2">{formatDate(appointment.when)}</td>
                  <td className="border border-gray-300 px-4 py-2">{formatTime(appointment.when)}</td>
                  <td className="border border-gray-300 px-4 py-2">{appointment.duration} min</td>
                  <td className="border border-gray-300 px-4 py-2">{appointment.type}</td>
                  <td className="border border-gray-300 px-4 py-2">
                    <button
                      onClick={() => handleEdit(appointment.id)}
                      className="bg-green-500 text-white px-3 py-1 rounded-lg text-sm hover:bg-green-600 font-medium"
                    >
                      Ändern
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="text-center text-gray-500 py-8">Keine Termine gefunden</div>
      )}
    </div>
  );
}
